import { useSelector } from 'react-redux';
import { selectApplication } from '../store/selectors/applicationSelectors';

const useIraApplicationData = () => {
  const Application = useSelector(selectApplication);

  const { IRAApplication } = Application;

  return {
    IRAApplication,
  };
};

export default useIraApplicationData;
